import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "px-3" }
const _hoisted_7 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_8 = { class: "p-field-checkbox d-flex align-items-center mt-3" }
const _hoisted_9 = { for: "ApplyAllThermostats" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.preferenceLabel)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.preferenceLabel), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.HeatingUpper")), 1),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.DelayHeatingPumps")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.delayHeatingPumps,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.delayHeatingPumps = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.delayHeatingPumps), 1)
    ]),
    _createVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.CoolingUpper")), 1),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.DelayCoolingPumps")), 1),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.delayCoolingPumps,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.delayCoolingPumps = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.delayCoolingPumps), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Checkbox, {
        id: "ApplyAllThermostats",
        name: "ApplyAllThermostats",
        modelValue: _ctx.roomObject.isApplyAllCirculationPumpDelay,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.roomObject.isApplyAllCirculationPumpDelay = $event)),
        binary: true,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.ApplyAllThermostats")), 1)
    ])
  ]))
}